import axios from 'axios';
import { API } from './api';
import { adminApi } from './adminAuth';

const urlB64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
};

export const isPushSupported = () =>
  typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export const getPushConfig = async () => {
  const { data } = await axios.get(`${API}/push-config`);
  return data;
};

export const registerAdminServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw-admin.js', { scope: '/' });
    return reg;
  } catch (e) {
    console.warn('SW registration failed', e);
    return null;
  }
};

export const requestPushPermission = async () => {
  if (!isPushSupported()) return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  const perm = await Notification.requestPermission();
  return perm;
};

export const subscribeToPush = async (vapidPublicKey) => {
  const reg = await registerAdminServiceWorker();
  if (!reg) throw new Error('Service worker not available');
  const perm = await requestPushPermission();
  if (perm !== 'granted') throw new Error(`Notification permission ${perm}`);
  const existing = await reg.pushManager.getSubscription();
  if (existing) return existing;
  const applicationServerKey = urlB64ToUint8Array(vapidPublicKey);
  const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
  await adminApi.post('/push/subscribe', sub.toJSON());
  return sub;
};

export const unsubscribeFromPush = async () => {
  if (!('serviceWorker' in navigator)) return;
  const reg = await navigator.serviceWorker.getRegistration('/');
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try { await adminApi.post('/push/unsubscribe', sub.toJSON()); } catch {}
    await sub.unsubscribe();
  }
};

export const getCurrentSubscription = async () => {
  if (!('serviceWorker' in navigator)) return null;
  const reg = await navigator.serviceWorker.getRegistration('/');
  if (!reg) return null;
  return reg.pushManager.getSubscription();
};

export const sendTestPush = async () => {
  return adminApi.post('/push/test');
};
